// Imports React
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load pages
const Home = lazy(() => import('./home'));

/**
 * Route configuration array
 */
const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

/**
 * Route settings to be used by RouterProvider in main.tsx
 */
export const router = createBrowserRouter(routes);
